<template>
  <section>
    <v-hover v-slot="{ hover }">
      <v-card height="100%" :elevation="hover ? 4 : 1" @click="onViewProduct" class="colorCard" style="border-radius: 0;">
        <v-img
          :src="
            product.PictureUrl != null ? product.PictureUrl : product.Picture
          "
          :aspect-ratio="1.618 / 1"
          style="background-color: white;"
          >
          <AddProductDirectlyBtn
            v-if="bookableDirectly(product)"
            class="add-btn"
            :product="product"
          />

          <!-- sold out text -->
          <template v-if="!hasCapacity(product)">
            <div class="sold-out-label-box"></div>
            <div
              class="sold-out-label-text"
              v-text="$translate('PRODUCT_SOLD_OUT')"
            ></div>
          </template>

          <!-- Highlighting label -->
          <HighlightingLabel
            :label="product.HighlightingLabel"
            :visible="product.Highlighted"
          />
        </v-img>

        <v-card-title class="text-break pt-1 px-3">
          <div class="text-truncate text-h6 font-weight-medium mx-auto">
            {{ product.Name }}
          </div>
        </v-card-title>

        <!-- <v-card-subtitle
          class="tdf-text-truncate px-3 py-1"
          v-html="product.Description"
        /> -->

        <v-card-text
          class="price text-center px-0 pb-0"
          style="min-height: 80px"
        >
          <v-col class="pa-0">
<!--            <v-row-->
<!--              class="ma-0 pa-0"-->
<!--              v-if="-->
<!--                product.AvailabilityBatchGroup !== null &&-->
<!--                product.AvailabilityBatchGroup.BatchGroupId != 0-->
<!--              "-->
<!--            >-->
<!--              <ProductAvailabilityInfo></ProductAvailabilityInfo>-->
<!--            </v-row>-->
            <!-- Unit price -->
            <v-row
              class="ma-0 text--primary d-inline-flex"
              justify="center"
              align="baseline"
            >
              <div
                v-if="showRetailUnitPrice"
                class="discount-price text-body-1 mr-1"
              >
                {{ formatter.format(retailUnitPrice) }}
              </div>

              <v-row
                v-if="showUnitPrice"
                class="ma-0"
                justify="center"
                align="baseline"
              >
                <div>
                  <span
                    class="text-h5"
                    :class="hasGeneralDiscount(product) ? 'red--text' : ''"
                  >
                    {{ formatter.format(unitPrice) }}
                  </span>
                  <span v-if="isWeightedProduct(product)" class="text-caption">
                    /
                    <span v-if="product.WeightedInfo.OverviewSize > 1">
                      {{ product.WeightedInfo.OverviewSize }}
                    </span>
                    {{ product.WeightedInfo.Unit }}
                  </span>
                </div>
                <span class="text-caption text--secondary ml-1">
                  {{ priceSuffix }}
                </span>
              </v-row>
            </v-row>

            <!-- Minimum quantity for Weighted product -->
          <v-col class="pa-0">
            <div
              v-if="
                isWeightedProduct(product) &&
                getDisplayMinQuantity(product) > 0
              "
              class="text-caption text--primary"
            >
              Minimum
              {{ getDisplayMinQuantity(product) }}
              {{ getDisplayUnit(product) }}
            </div>
            <!-- availability info -->
            <v-row
              class="ma-0 pa-0"
              v-if="
                product.AvailabilityBatchGroup !== null &&
                product.AvailabilityBatchGroup.BatchGroupId != 0
              "
            >
              <ProductAvailabilityInfo></ProductAvailabilityInfo>
            </v-row>
            <div v-if="product.DepositValue > 0"
                 class="text-caption text--primary py-0 my-0">
              {{ $translate('DEPOSIT_VALUE') }} : {{ formatter.format(product.DepositValue) }}
            </div>
          </v-col>
          </v-col>
        </v-card-text>

        <!-- <v-row class="ma-0 px-4 py-2" justify="center">
          <v-btn
            class="primary-font-color"
            rounded
            elevation="0"
            color="primary"
            @click="onViewProduct"
          >
            {{ $translate('VIEW') }}
          </v-btn>
        </v-row> -->
      </v-card>
    </v-hover>

    <!-- product dialog -->
    <ProductOrderDialog
      v-if="showProductDialog"
      :showDialog="showProductDialog"
      :product="product"
      @close="showProductDialog = false"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import utility from '@/shared/utility';
import {
  hasGeneralDiscount,
  isOnDiscount,
  personalDiscount,
  applyPersonalDiscount,
  isWeightedProduct,
  getUnitPrice,
  getRetailUnitPrice,
  getOverviewPrice,
  getRetailOverviewPrice,
  hasCapacity,
  getDisplayMinQuantity,
  getDisplayUnit,
  getDisplayStepSize,
  bookableDirectly,
} from '@/objects/Product';
import ProductOrderDialog from '@/components/event/eventDetails/productOrderComponents/ProductOrderDialog';
import HighlightingLabel from '@/components/generalComponents/HighlightingLabel';
import AddProductDirectlyBtn from '@/components/event/eventDetails/productOrderComponents/AddProductDirectlyBtn';
import ProductAvailabilityInfo from '@/components/event/eventDetails/productOrderComponents/ProductAvailabilityInfo';

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  emits: ['view'],
  components: {
    ProductOrderDialog,
    HighlightingLabel,
    AddProductDirectlyBtn,
    ProductAvailabilityInfo,
  },
  computed: {
    ...mapGetters({
      isProfUser: 'isProfUser',
    }),
    retailUnitPrice() {
      if (isWeightedProduct(this.product)) {
        if (hasGeneralDiscount(this.product)) {
          return getRetailOverviewPrice(this.product);
        }
        return getOverviewPrice(this.product);
      }

      if (hasGeneralDiscount(this.product)) {
        return getRetailUnitPrice(this.product);
      }
      return getUnitPrice(this.product);
    },
    unitPrice() {
      if (isWeightedProduct(this.product)) {
        return this.getPriceForPersonalDiscount(
          getOverviewPrice(this.product),
          this.product
        );
      }

      return this.getPriceForPersonalDiscount(
        getUnitPrice(this.product),
        this.product
      );
    },

    priceSuffix() {
      if (this.isProfUser) {
        return this.$translate('EXCL_VAT');
      }
      return '';
    },
    showRetailUnitPrice() {
      return (
        this.showUnitPrice &&
        isOnDiscount(this.product) &&
        this.retailUnitPrice != null &&
        this.retailUnitPrice > 0 &&
        this.unitPrice != null &&
        this.retailUnitPrice > this.unitPrice
      );
    },
    showUnitPrice() {
      if (this.product.Type === 'Rental' && this.unitPrice < 0.005) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
      showProductDialog: false,
    };
  },
   mounted() {
    this.initPrimaryColorWithOpacity()
   },
  methods: {
    // External methods
    hasGeneralDiscount,
    isOnDiscount,
    isWeightedProduct,
    hasCapacity,
    getDisplayMinQuantity,
    getDisplayUnit,
    getDisplayStepSize,
    bookableDirectly,

    // Internal methods
    getPriceForPersonalDiscount(originalPrice) {
      let price = originalPrice;
      if (applyPersonalDiscount(this.product)) {
        price = utility.getDiscountPrice(
          originalPrice,
          personalDiscount(this.product)
        );
      }
      return price;
    },
    onAddProduct() {
      // Add product directly to shopping cart / list
      this.showProductDialog = true;
    },
    initPrimaryColorWithOpacity() {
      const opacityHexValue = '26';
      const selector = document.querySelector(':root');
      selector.style.setProperty(
        '--primary-color-opacity1',
        `${this.$vuetify.theme.themes.light.primary}${opacityHexValue}`
      );
    },
    onViewProduct() {
      if (this.product == null) {
        console.error('View product error - Product is null');
      }

      this.$store.commit('event/setCurrentWatchedProduct', this.product);

      if (this.product.MetaData != null) {
        window.EventBus.fire('updateMetaData', this.product.MetaData);
      }

      // route to the product details
      if (
        this.product.Categories != null &&
        this.product.Categories.length > 0
      ) {
        this.$router.push({
          name: 'ProductWithCategory',
          params: {
            event_id: this.product.EventId,
            category_id: this.product.Categories[0].Id,
            product_id: this.product.Id,
          },
        });
      } else {
        this.$router.push({
          name: 'ProductWithoutCategory',
          params: {
            event_id: this.product.EventId,
            product_id: this.product.Id,
          },
        });
      }

      this.$emit('view');
    },
  },
};
</script>

<style lang="scss" scoped>
.add-btn {
  position: absolute;
  top: 3px;
  right: 3px;
}
.sold-out-label-box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(192, 192, 192, 0.65);
}
.sold-out-label-text {
  position: absolute;
  top: 0;
  left: 0;
  display: inline;
  background-color: #ff3333;
  color: white;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 8px;
}
.tdf-text-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 2px;
  height: 3.2rem;
}
.price {
  font-size: 18px;
};
.colorCard {
  background-color: var(--primary-color-opacity1);
};
</style>
